.root {
  display: inline-block;
  vertical-align: middle;
}

.mountainFar,
.mountainMid,
.mountainNear {
  transition: transform var(--duration-base) var(--ease-out);
  transform-box: fill-box;
  transform-origin: center bottom;
  /* Shared animation settings — name and delay are direction-specific. */
  animation-duration: 1400ms;
  animation-timing-function: cubic-bezier(0.5, 1.8, 0.6, 1);
}

.mountainFar  { animation-name: logoWaveFar; }
.mountainMid  { animation-name: logoWaveMid; }
.mountainNear { animation-name: logoWaveNear; }

/* Back-to-front: far peak appears first, near last. */
.b2f .mountainFar  { animation-delay: 0ms; }
.b2f .mountainMid  { animation-delay: 80ms; }
.b2f .mountainNear { animation-delay: 160ms; }

/* Front-to-back: near peak appears first, far last. */
.f2b .mountainNear { animation-delay: 0ms; }
.f2b .mountainMid  { animation-delay: 80ms; }
.f2b .mountainFar  { animation-delay: 160ms; }

/* Doubled amplitude vs. the original draft — visible "wave" rather
   than a hint. The 35% keyframe is the peak; the bounce easing
   overshoots it briefly before settling back to 0. */
@keyframes logoWaveFar {
  0%   { transform: translate(0, 0); }
  35%  { transform: translate(10px, -12px); }
  100% { transform: translate(0, 0); }
}

@keyframes logoWaveMid {
  0%   { transform: translate(0, 0); }
  35%  { transform: translate(-7px, -14px); }
  100% { transform: translate(0, 0); }
}

@keyframes logoWaveNear {
  0%   { transform: translate(0, 0); }
  35%  { transform: translate(-10px, 9px); }
  100% { transform: translate(0, 0); }
}

/* Hover — visible drift, applied via transition after the mount
   animation has finished returning to translate(0, 0). */
.root:hover .mountainFar {
  transform: translate(2px, -2px);
}

.root:hover .mountainMid {
  transform: translate(-2px, -3px);
}

.root:hover .mountainNear {
  transform: translate(-2.5px, 1.5px);
}

@media (prefers-reduced-motion: reduce) {
  .mountainFar,
  .mountainMid,
  .mountainNear {
    transition: none;
    animation: none;
  }
  .root:hover .mountainFar,
  .root:hover .mountainMid,
  .root:hover .mountainNear {
    transform: none;
  }
}
